import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'complexes/objects/btiplacements',
  urlRoot: 'complexes/objects/btiplacements',
  
  state: {
    total: 0,
    list: [],
    object: {}
  },

  parseList(response) {
    // eslint-disable-next-line no-console
    // sconsole.log(response.data.object)
    return Object.assign({}, response, {
      list: response.data.list,
      object: response.data.object
    })

  },
  onFetchListSuccess(state, response,{list}) {
    // eslint-disable-next-line no-console
    console.log(list)

    state.list = response.list
    state.object = response.object
        // eslint-disable-next-line no-console
    console.log(state)
  },

  mutations: {

  },

  actions: {

  }
})

export default withDataFilter(store)
